import Vue from 'vue'

const mutations = {

  SET_PACKAGE_VERSION (state, version) {
    Vue.set(state, 'package_version', version)
  },
  SET_USER (state, user) {
    if (!state.user.id) {
      state.user = user
    } else {
      state.user.compactViewActive = user.user.compactViewActive
      state.user.deviceTagDropdownViewActive = user.user.deviceTagDropdownViewActive
      state.user.mediumTagDropdownViewActive = user.user.mediumTagDropdownViewActive
    }
  },
  SET_CSRF_TOKEN (state, csrfToken) {
    state.csrfToken = csrfToken
  },
  SET_LIVE_MODE (state, liveMode) {
    state.liveMode = liveMode
  },
  ADD_ADMIN_NETWORK (state, network) {
    state.user.Networks.push(network)
    Vue.set(state.user, 'Networks', state.user.Networks)
  },
  RESET_USER (state) {
    state.user = {}
  },

  /**
   * @param state
   * @param lastNetworkId {integer}
   * @constructor
   */
  SET_LAST_NETWORK_ID (state, lastNetworkId) {
    state.user.lastNetworkId = lastNetworkId
  },

  /**
   * @param state
   * @param status {bool}
   * @constructor
   */
  SET_NETWORK_STATUS (state, status) {
    state.networkChosen = status
  },

  SET_USERLIST (state, users) {
    Vue.set(state, 'user_list', users)
  },
  SET_USERLIST_NETWORK (state, users) {
    Vue.set(state, 'user_list_network', users)
  },
  ADD_USER_TO_USERLIST (state, userData) {
    state.user_list.push(userData)
  },

  UPDATE_USER_IN_USERLIST (state, userData) {
    let updatedUserIndex = state.user_list.findIndex(oldUser => oldUser.id === userData.id)
    if (updatedUserIndex !== -1) {
      Vue.set(state.user_list, updatedUserIndex, userData)
    }
  },
  TOGGLE_RIGHT_PANEL_CHOSEN (state) {
    state.rightPanelChosen = state.rightPanelChosen === 'devices' ? 'media' : 'devices'
  },
  SET_RIGHT_PANEL_CHOSEN (state, target) {
    state.rightPanelChosen = target
  },
  SET_LEFT_PANEL_CHOSEN (state, target) {
    state.leftPanelChosen = target
  },
  SET_FOCUSED_SIDE (state, side) {
    state.focused_side = side
  },
  SET_CHANGING_NETWORK_STATUS_DEVICES (state, status) {
    state.changing_network_status_devices = status
  },
  SET_CHANGING_NETWORK_STATUS_MEDIA (state, status) {
    state.changing_network_status_media = status
  },
  SET_AUTH_PROVIDERS(state, providers) {
    state.providers = providers;
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/user/user.mutations.js
// module id = null
// module chunks = 